module.exports = __webpack_public_path__ + "media/images/icon/icons8-Save as-13669573581b23b8ca7f6b643e2ac9b9.png";